<template>
  <b-modal
    centered
    v-bind="$attrs"
    v-on="$listeners"
    hide-footer
    size="xl"
    body-class="p-4"
    header-class="px-4 d-flex align-items-center"
    @hidden="tabIndex = openedTab"
  >
    <template v-slot:modal-header>
      <b-button v-if="tabIndex" type="button" aria-label="Back" @click="tabIndex--" variant="link" class="text-dark">
        <i class="fal fa-arrow-left"></i>
      </b-button>
      <h6 class="lh-150 font-weight-normal mb-0">{{ tabIndex ? $t('preview.title') : $t('header-title') }}</h6>
      <div class="fix-opacity close py-0 d-flex">
        <b-button v-if="theme && tabIndex === 0" variant="outline-green" @click="tabIndex++">
          {{ $t('button.view-theme') }}
        </b-button>
        <b-button type="button" aria-label="Close" @click="close" variant="link" class="text-dark ml-2">
          <i class="fal fa-times"></i>
        </b-button>
      </div>
    </template>
    <b-tabs v-model="tabIndex" nav-class="d-none" nav-wrapper-class="d-none">
      <b-tab v-for="(tab, index) in tabs" :key="index">
        <component v-bind:is="tab.component" :theme="theme" v-bind="$attrs" v-on="$listeners" @close="close" />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
export const modalTabs = Object.freeze({
  FORM: 0,
  PREVIEW: 1,
})

export default {
  i18nOptions: { keyPrefix: 'components.theme-modal.save-theme-confirmation' },
  props: {
    openedTab: {
      type: Number,
      default: modalTabs.FORM,
    },
    theme: {
      type: Object,
    },
  },
  computed: {
    tabs() {
      return [{ component: () => import('./ThemeForm') }, { component: () => import('./Preview') }]
    },
  },
  data() {
    return {
      tabIndex: this.openedTab,
    }
  },
  watch: {
    openedTab(newIndex, oldIndex) {
      if (newIndex !== oldIndex) this.tabIndex = newIndex
    },
  },
  methods: {
    close() {
      this.$bvModal.hide(this.$attrs.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.fix-opacity {
  opacity: 1 !important;
}
</style>
